@if (container.currentTab === tab) {
  <div>
    <ng-content></ng-content>
  </div>
}
